import React from 'react';
// import logo from './logo.svg';
import './App.css';

import MapComponent from './components/marker';

function App() {
  return (
    <div className="App">
      <MapComponent />
    </div>
  );
}

export default App;
